<template>

   <div>
       <div v-for="resour in resource">

           <div v-if="resour.type !== 1">
               <div class="other-resouce" v-if="resour.type == 5">
                   <a :href="resour.data.url" target="_blank">
                       <div>{{resour.name}}</div>
                       <div>Fecha: {{resour.data.date}}</div>
                   </a></div>
           </div>
           <div class="other-resouce" v-if="resour.type === 4 || resour.type === 3">
               <a :href="resour.data.url" target="_blank">
                   <div>{{resour.name}}</div>
               </a>
           </div>
       </div>

   </div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'resourceSectionVideo',
        components: {

        },
        created(){

        },
        props:['resource',],
        data(){
            return {
                lesson:''
            }
        },
        computed: {
            ...mapState,



        },
        methods:{

        },


    }
</script>
<style scoped>
    .other-resouce{
        display: flex;
        flex-direction: column;
        cursor: pointer;
        font-size: 1.1rem;
        color: black;
        padding: 8px 10px;
        border-bottom: solid .5px #C4BCF3;
    }
    a{
        text-decoration: none;
    }
    .other-resouce:hover{
        background-color: #EFEDFC;
    }
</style>